import { FloatingPosition, Menu, Skeleton } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { User } from '../../../@types/user';
import useLogout from '../../../hooks/useLogout';
import { Avatar } from '../../Atoms';

import { IconLogout, IconSelector } from '@tabler/icons-react';

interface AccountMenuButtonProps {
    user?: User;
    menuPosition?: FloatingPosition | undefined;
}

export default function AccountMenuButton({ user, menuPosition }: AccountMenuButtonProps) {
    const [menuOpened, setMenuOpened] = useState(false);
    const logout = useLogout();
    const { t } = useTranslation('common');

    if (!user) {
        return (
            <div className="flex flex-row justify-start items-center gap-2 overflow-hidden">
                <Skeleton height={48} width={48} />
                <div className="hidden flex-col justify-start items-start gap-2 lg:flex">
                    <Skeleton height={20} width={120} />
                    <Skeleton height={20} width={160} />
                </div>
            </div>
        );
    }

    return (
        <Menu position={menuPosition || 'right'} opened={menuOpened} onChange={setMenuOpened}>
            <Menu.Target>
                <button
                    className={`p-0 w-auto flex flex-row justify-between items-center rounded-md transition-all duration-100 cursor-pointer overflow-hidden hover:bg-fg/5 lg:w-full lg:p-1`}
                >
                    <div className="flex flex-row justify-start items-center gap-2 ">
                        <Avatar
                            value={`${user.id}:${user.email}:${user.information.firstName}:${user.information.lastName}`}
                        />
                        <span className="sr-only lg:hidden">
                            {t('menu.account', {
                                name:
                                    [user.information.firstName, user.information.lastName]
                                        .filter(Boolean)
                                        .join(' ') || user.email,
                            })}
                        </span>
                        <div className="hidden flex-col justify-start items-start lg:flex">
                            <p className="max-w-44 truncate text-[15px] font-bold text-fg">
                                {user.information.firstName || user.email.split('@')[0]}
                                {user.information.lastName ? ` ${user.information.lastName}` : ''}
                            </p>
                            <p className="max-w-44 truncate  text-[15px] text-fg/78">
                                {user.email}
                            </p>
                        </div>
                    </div>
                    <IconSelector size={20} className={`hidden lg:block`} />
                </button>
            </Menu.Target>

            <Menu.Dropdown>
                <Menu.Label>{t('menu.shortcut')}</Menu.Label>
                <Menu.Item
                    leftSection={<IconLogout size={18} />}
                    color="var(--color-status-danger)"
                    onClick={() => {
                        logout();
                        setMenuOpened(false);
                    }}
                >
                    {t('menu.logout')}
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
}
